import { SegmentListViewEvent, segmentTrackAction } from '../../../../middlewares/segment';
import { ActionCreator } from 'redux';
import { Dispatch, ThunkAction } from '../../../../types/actions';
import { ECardField, IOrderType } from '../store/listViewBoard/types';
import { SegmentListViewOption } from '../../../../middlewares/segment/trackEntities/listViewEvents';

export const groupByEpicsSegmentEvent: ActionCreator<ThunkAction> = (
    isGrouped: boolean
) => {
    const action = (
        dispatch: Dispatch
    ) => {
        const segmentEvent = isGrouped ? SegmentListViewEvent.GROUP_SUB_CARDS_WITH_EPICS_OFF : SegmentListViewEvent.GROUP_SUB_CARDS_WITH_EPICS_ON;
        dispatch(segmentTrackAction(segmentEvent))
    };
    return action;
};

export const sortingSegmentEvent: ActionCreator<ThunkAction> = (
    orderType: IOrderType
) => (
    dispatch: Dispatch
) => {
    if (orderType) {
        const {field, isAsc} = orderType;
        const sortingType = field;
        const sortingOrder = isAsc ? 'ASC' : 'DESC';
        dispatch(segmentTrackAction(SegmentListViewEvent.SORTING_ENABLED, {name: sortingType, value: sortingOrder}));
    } else {
        dispatch(segmentTrackAction(SegmentListViewEvent.SORTING_DISABLED));
    }
};

export const sortingTypeInSettingsSegmentEvent: ActionCreator<ThunkAction> = (
    field: ECardField,
    active: boolean
) => {
    const action = (
        dispatch: Dispatch
    ) => {
        const segmentEvent = active ? SegmentListViewEvent.SORTING_TYPE_ADDED_IN_SETTINGS : SegmentListViewEvent.SORTING_TYPE_REMOVED_FROM_SETTINGS;
        dispatch(segmentTrackAction(segmentEvent,
            {
                name: SegmentListViewOption.TYPE,
                value: field
            }));
    };
    return action;
};

export const sortingTypeSegmentEvent: ActionCreator<ThunkAction> = (
    isManual: boolean
) => {
    const action = (
        dispatch: Dispatch
    ) => {
        const segmentEvent = isManual ? SegmentListViewEvent.MANUAL_SORT_TYPE : SegmentListViewEvent.CHRONOLOGICAL_SORT_TYPE;
        dispatch(segmentTrackAction(segmentEvent));
    };
    return action;
};

export const settingsClickedSegmentEvent: ActionCreator<ThunkAction> = () => {
    const action = (
        dispatch: Dispatch
    ) => {
        dispatch(segmentTrackAction(SegmentListViewEvent.SETTINGS_CLICKED));
    };
    return action;
};

export const cardClickedSegmentEvent: ActionCreator<ThunkAction> = () => {
    const action = (
        dispatch: Dispatch
    ) => {
        dispatch(segmentTrackAction(SegmentListViewEvent.CARD_CLICKED));
    };
    return action;
};

export const resetSettingsClickedSegmentEvent: ActionCreator<ThunkAction> = () => {
    const action = (
        dispatch: Dispatch
    ) => {
        dispatch(segmentTrackAction(SegmentListViewEvent.RESET_SETTINGS_CLICKED));
    };
    return action;
};

export const collapseGroupsSegmentEvent: ActionCreator<ThunkAction> = (
    collapse: boolean
) => {
    const action = (
        dispatch: Dispatch
    ) => {
        const segmentEvent = collapse ? SegmentListViewEvent.COLLAPSE_ALL_GROUPS : SegmentListViewEvent.EXPAND_ALL_GROUPS;
        dispatch(segmentTrackAction(segmentEvent));
    };
    return action;
};

export const printClickedSegmentEvent: ActionCreator<ThunkAction> = () => {
    const action = (
        dispatch: Dispatch
    ) => {
        dispatch(segmentTrackAction(SegmentListViewEvent.PRINT_CLICKED));
    };
    return action;
};

export const cardOrderChangedSegmentEvent: ActionCreator<ThunkAction> = () => {
    const action = (
        dispatch: Dispatch
    ) => {
        dispatch(segmentTrackAction(SegmentListViewEvent.CARD_ORDER_CHANGED));
    };
    return action;
};
